import * as React from "react";
import { useEffect, useRef } from "react";
import styled from "@mui/material/styles/styled";
import { Button } from "@mui/material";
import { CHAT_ELEMENT_HEIGHT } from "../consts/sizeConsts";
import { useTranslate } from "../../hooks/useTranslate";
import { PatientColorMap } from "../../layout/patientColorMap";
import clsx from "clsx";
import { WidgetAlignment } from "../../d";
import { useWidgetSettings } from "../../widget/useWidgetSettings";
import { usePatientFeatureFlags } from "../../hooks/usePatientFeatureFlags";

//region [[ Styles ]]

const ContinueButtonView = styled(Button)(({ theme }) => ({
  "&.continue-button": {
    color: PatientColorMap.ButtonTextColor,
    fontWeight: 500,
    fontSize: "15px",
    backgroundColor: PatientColorMap.Primary,
    height: CHAT_ELEMENT_HEIGHT,
    minWidth: "120px",
    textTransform: "capitalize",
    width: "100px",
    borderRadius: "30px",
    boxShadow: "unset",
    "&:focus, &:hover, &:active": {
      color: PatientColorMap.ButtonTextColor,
      boxShadow: "unset",
      backgroundColor: PatientColorMap.PrimaryDark,
    },
  },
}));
//endregion [[ Styles ]]

//region [[ Props ]]

export interface ContinueButtonProps {
  onClick: (event) => void;
  className?: string;
  disabled?: boolean;
  skipScroll?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ContinueButton = (props: ContinueButtonProps) => {
  const buttonRef = useRef<any>();

  const { translate } = useTranslate();

  const { windowAlignment } = useWidgetSettings();

  const scrollToLastAnswer = usePatientFeatureFlags("scrollToLastAnswerOnly");

  useEffect(() => {
    setTimeout(() => {
      if (
        buttonRef?.current &&
        !props.skipScroll &&
        !props.disabled &&
        windowAlignment !== WidgetAlignment.inline &&
        !scrollToLastAnswer
      ) {
        buttonRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "center",
        });
      }
    }, 500);
  }, [props, windowAlignment, scrollToLastAnswer]);

  return (
    <ContinueButtonView
      className={clsx(
        props.className,
        "continue-button",
        props.disabled ? "disabled" : "",
      )}
      variant={"contained"}
      onClick={props.onClick}
      ref={buttonRef}
      disabled={props.disabled}
    >
      {translate("CONTINUE")}
    </ContinueButtonView>
  );
};
